import { DATE_FORMAT_OPTION_NUMERIC_2DIGIT, DATE_TIME_FORMAT_OPTION_RELDATE } from '@/data/constants/dateTime';
import { parseISO , format } from 'date-fns';

type Props = {
	dateString: string
}

export const DateFormatter = ({ dateString }: Props) => {
	const date = parseISO(dateString)
	return format(date, 'LLL d, yyyy')
}

export function ReleaseDateFormat(dateString : string) {
    const date = new Date(dateString);
    return (
        date.toLocaleDateString('nl-NL',  DATE_TIME_FORMAT_OPTION_RELDATE)
    )
}

export function NumericDateFormatter2Digits({ dateString }: Props) {
    const date = new Date(dateString);
    return (
        date.toLocaleDateString('nl-NL',  DATE_FORMAT_OPTION_NUMERIC_2DIGIT)
    )
}

export const calculateAge = (birthday:Date) => {
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const checkForAllowedAge = (dateOfBirth:string, allowedAge:number) => {
    if(!dateOfBirth)return true;
    const user_age = calculateAge(new Date(dateOfBirth));
    return user_age >=allowedAge;
}